<template>
    <div class="cabinet-content-inner">

        <div class="cabinet-notice-big subscribe-text-error">
            <div class="icon"><FailIcon/></div>
            <div class="text">Не удалось оформить подписку. <br>Попробовать еще раз?</div>
        </div>

        <div class="form">

            <div class="button-block">
                <button @click="confirmSubscription" class="button button-dark">Оформить подписку</button>
            </div>

        </div>

    </div>
</template>

<script>
    import FailIcon from "../icons/FailIcon";
    export default {
        name: "SubscriptionError",
        components: {FailIcon},
        methods: {
            confirmSubscription() {
                this.$emit('confirmSubscription');
            }
        }
    }
</script>

<style scoped>

</style>